class WLSUgc extends HTMLElement {
    constructor() {
        super();

        this.classes = {
            playingClass: 'playing',
            dotClass: 'dot',
            isSelectedClass: 'is-selected',
            slider: 'carousel',
            item: 'carousel-cell',
            video: 'js-wls-ugc-video',
            navigation: {
                prev: 'js-wls-ugc-prev',
                next: 'js-wls-ugc-next',
                pagination: 'js-wls-ugc-dots'
            }
        };

        this.elements = {
            slider: this.querySelector(`.${this.classes.slider}`),
            items: this.querySelectorAll(`.${this.classes.item}`),
            videos: this.querySelectorAll(`.${this.classes.video}`),
            navigation: {
                prev: this.querySelector(`.${this.classes.navigation.prev}`),
                next: this.querySelector(`.${this.classes.navigation.next}`),
                pagination: this.querySelector(`.${this.classes.navigation.pagination}`)
            }
        };

        // this.resizeHandler = this.handleResize.bind(this);
    }

    connectedCallback() {
        if (this.checkIfEmpty()) return;
        this.init();
        this.checkVideos();
        window.addEventListener('resize', this.resizeHandler);
    }

    disconnectedCallback() {
        if (this.flickity) {
            this.flickity.destroy();
        }
        window.removeEventListener('resize', this.resizeHandler);
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
    }

    checkVideos() {
        if (this.elements.videos.length > 0) {
            this.elements.videos.forEach((video) => {
                const parentItem = video.closest(".js-wls-ugc-carousel-video");
                video.addEventListener("click", () =>
                    this.toggleVideoPlay(video, parentItem),
                );
            });
        } else {
            requestAnimationFrame(this.checkVideos.bind(this));
        }
    }

    toggleVideoPlay(video, parentItem) {
        this.stopPlayingCurrentVideo(video.id);
        if (video.paused) {
            video.play();
        } else {
            video.pause();
        }
        if (parentItem) {
            parentItem.classList.toggle(this.classes.playingClass, !video.paused);
        }
    }

    stopPlayingCurrentVideo(videoId) {
        const currentPlayingParent = document.querySelector(
            ".js-wls-ugc-carousel-video.playing",
        );
        if (currentPlayingParent) {
            currentPlayingParent.classList.remove(this.classes.playingClass);
            const currentPlayingVideo = currentPlayingParent.querySelector("video");
            if (currentPlayingVideo?.id !== videoId) {
                currentPlayingVideo.pause();
            }
        }
    }

    checkIfEmpty() {
        const sliderInner = this.elements.slider;
        if (!sliderInner || !sliderInner.children.length) {
            this.style.display = 'none';
            return true;
        }
        return false;
    }

    init() {
        if (!this.shouldInitialize()) return;
        this.initializeFlickity();
    }

    shouldInitialize() {
        if (!this.elements.slider || !this.elements.items.length) return false;

        const width = window.innerWidth;
        const slidesCount = this.elements.items.length;

        if (width < 768 && slidesCount <= 1) return false;
        if (width >= 768 && width < 1024 && slidesCount <= 3) return false;
        if (width >= 1024 && slidesCount <= 4) return false;

        return true;
    }



    initializeFlickity() {
        const isDesktop = window.innerWidth >= 1024;
        this.flickity = new Flickity(this.elements.slider, {
            cellAlign: 'left',
            wrapAround: true,
            pageDots: true,
            prevNextButtons: false,
            cellSpacing: isDesktop ? 24 : 16
        });

        // Navigation
        if (this.elements.navigation.prev) {
            this.elements.navigation.prev.addEventListener('click', () => {
                this.flickity.previous();
            });
        }

        if (this.elements.navigation.next) {
            this.elements.navigation.next.addEventListener('click', () => {
                this.flickity.next();
            });
        }
    }
}

if (!customElements.get('wls-ugc')) {
    customElements.define('wls-ugc', WLSUgc);
}
